"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Common_module_css_1 = __importDefault(require("./Common.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var material_1 = require("@mui/material");
var ResourceDeleteErrorModal = function (props) {
    var detachResourceMethod = props.detachResourceMethod, deleteResourceMethod = props.deleteResourceMethod, resourceId = props.resourceId, message = props.message, data = props.data, resourceDetachError = props.resourceDetachError, subTitleText = props.subTitleText, resourceAttachedToText = props.resourceAttachedToText, tooltipText = props.tooltipText, detachErrorTest = props.detachErrorTest, rest = __rest(props, ["detachResourceMethod", "deleteResourceMethod", "resourceId", "message", "data", "resourceDetachError", "subTitleText", "resourceAttachedToText", "tooltipText", "detachErrorTest"]);
    var t = (0, react_i18next_1.useTranslation)("translation").t;
    return (react_1.default.createElement(q_play_components_1.Modal, __assign({}, rest, { dialogClassName: "".concat(Common_module_css_1.default["modalDialog"], " ").concat(Common_module_css_1.default["remove-resource-error-dialog"]), centered: true, body: react_1.default.createElement(react_1.default.Fragment, null,
            subTitleText,
            ".",
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            message && "".concat(t(message), "."),
            (data === null || data === void 0 ? void 0 : data.length) > 0 &&
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null,
                        resourceAttachedToText,
                        ":"),
                    react_1.default.createElement("div", { className: "d-flex flex-column gap-2" }, data.map(function (resourceLinkInfo, index) {
                        var isEvent = resourceLinkInfo.resource_type === "EVENT";
                        return (react_1.default.createElement("div", { key: index, className: "d-flex align-items-center" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleRight, color: "var(--primary-color)", size: "lg" }),
                            react_1.default.createElement("span", { style: { marginLeft: "1em" } }, resourceLinkInfo.resource_name),
                            react_1.default.createElement(material_1.Tooltip, { title: tooltipText(resourceLinkInfo.resource_type), placement: "right" },
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", icon: pro_solid_svg_icons_1.faLinkSlash, iconSize: "1x", iconColor: "var(--cancel-color)", onClick: function () { return detachResourceMethod(resourceLinkInfo.primary_resource_id, resourceLinkInfo.secondary_resource_id, isEvent); } })))));
                    }))),
            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center", style: { marginTop: "1em" } },
                react_1.default.createElement("span", { style: { color: "var(--error-color)", visibility: resourceDetachError ? "initial" : "hidden" } }, detachErrorTest),
                react_1.default.createElement(q_play_components_1.Button, { text: t("Try again"), isDisabled: (data === null || data === void 0 ? void 0 : data.length) > 0, onClick: function () { return deleteResourceMethod(resourceId); } }))) })));
};
exports.default = ResourceDeleteErrorModal;
